
import { m } from 'framer-motion';
import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
// components
import { alpha, useTheme } from '@mui/material/styles';
import { MotionContainer, varFade } from 'src/components/animate';
import { bgGradient } from 'src/theme/css';
// ----------------------------------------------------------------------

export default function AboutHero({ data }) {
  
  const theme = useTheme();
  
  return (
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.grey[900], 0.8),
        }),
        height: { md: 400 },
        py: { xs: 10, md: 0 },
        borderRadius: '.7rem .7rem .7rem .7rem',
        overflow: 'hidden',
        position: 'relative',
        backgroundSize: 'cover',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginX: ".5rem",
        backgroundImage:
          `
          url(${process.env.PUBLIC_URL}/assets/background/overlay_1.svg), 
          url(${process.env.PUBLIC_URL}/assets/aboutusImage.jpg)
          `,
      }}
    >
      <Container sx={{ textAlign: 'center' }} component={MotionContainer}>
        <Box
          sx={{
            bottom: { md: 20 },

          }}
        >
          <TextAnimate text={data?.title || "Who"} variants={varFade().inRight} sx={{ color: 'primary.main', marginRight: '1rem' }} />

          <Stack spacing={2} display="inline-flex" direction="row" >
            {data?.list ? (
              data?.list?.map((v, index) => (
                <TextAnimate key={index} text={v} sx={{ color: '#fff' }} />
              ))
            ) : (
              <>
                <TextAnimate text="We" />
                <TextAnimate text="are?" />
              </>
            )}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------

function TextAnimate({ text, variants, sx, ...other }) {


  return (
    <Box
      component={m.div}
      sx={{
        typography: 'h1',
        overflow: 'hidden',
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >

      <m.span variants={variants || varFade().inUp}>
        {text}
      </m.span>

    </Box>
  );
}

TextAnimate.propTypes = {
  sx: PropTypes.object,
  text: PropTypes.string,
  variants: PropTypes.object,
};
